module.exports = __webpack_public_path__ + "media/images/doti-hello-9f9444462754b21a32148cb2c2d984a3.png";